import axios, { AxiosRequestConfig } from 'axios'
import { ChartDayData, PoolData, ProtocolData, TokenData, Transaction } from 'views/V3Info/types'

interface Result<T> {
  error: boolean
  data: T | undefined
}

export class SApiProvider {
  baseApiUrl: string

  constructor(baseApiUrl: string) {
    this.baseApiUrl = baseApiUrl
  }

  requestBase<T = any>(
    path: string,
    method: 'get' | 'post' | 'put' | 'delete',
    data: any,
    config: any = {
      headers: {},
    },
  ): Promise<T> {
    return new Promise((resolve, reject) => {
      const req = {
        url: this.baseApiUrl + path,
        method,
        params: undefined,
        data: undefined,
        headers: {},
      }
      if (['get', 'delete'].indexOf(method.toLowerCase()) > -1) {
        req.params = data
      } else {
        req.data = data
      }
      if (config.headers) {
        req.headers = config.headers
      }

      axios(req as AxiosRequestConfig)
        .then((res) => {
          if (res.data.statusCode !== 200) {
            reject(res.data.message)
          } else {
            // console.log("SAPIProvider request success", res.data.data)
            resolve(res.data.data as T)
          }
        })
        .catch((err) => {
          const msg = 'Network Error'
          console.error('SAPIProvider request error', err)
          reject(msg)
        })
    })
  }

  async tryRequest<T = any>(
    path: string,
    method: 'get' | 'post' | 'put' | 'delete',
    data: any,
    config: any = {
      headers: {},
    },
  ): Promise<Result<T>> {
    try {
      const result = await this.requestBase(path, method, data, config)
      return {
        error: false,
        data: result,
      }
    } catch (e) {
      return {
        error: true,
        data: undefined,
      }
    }
  }

  async protocolData(): Promise<Result<ProtocolData>> {
    return this.tryRequest<ProtocolData>('/protocolData', 'get', {})
  }

  async chartData(): Promise<Result<ChartDayData[]>> {
    return this.tryRequest<ChartDayData[]>('/chartData', 'get', {})
  }

  async topPool(): Promise<Result<Record<string, PoolData>>> {
    return this.tryRequest<Record<string, PoolData>>('/topPool', 'get', {})
  }

  async topToken(): Promise<Result<Record<string, TokenData>>> {
    return this.tryRequest<Record<string, TokenData>>('/topToken', 'get', {})
  }

  async topTransactions(): Promise<Result<Transaction[]>> {
    return this.tryRequest<Transaction[]>('/topTransactions', 'get', {})
  }
}
